import getHelper from '../../../services/getHelper';

export default getHelper('/supports/:id', {
  expertAssignment: getHelper('/expert-assignment/:id'),
  expertReplacement: getHelper('/expert-replacement/:id'),
});
